
const RefundResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
	"success": true,
	"code": "string",
	"providerName": "string",
	"ticketPrice": 0,
	"refundAmount": 0,
	"userId": "string",
	"username": "string",
	"refundCode": "string"
};
 

export default RefundResponse;
  